import { render } from "./admin-orders.vue?vue&type=template&id=23a2e686&scoped=true"
import script from "./admin-orders.vue?vue&type=script&lang=js"
export * from "./admin-orders.vue?vue&type=script&lang=js"

import "./admin-orders.vue?vue&type=style&index=0&id=23a2e686&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a2e686"]])

export default __exports__